import React, { useState, useEffect, useRef } from 'react';
import "./pgmdetails.scss";
import Sidebar from "../Sidebar";
import { HiMenu, HiX } from "react-icons/hi";
import { pgmdetailAction } from "../../actions/pgmlistAction";
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { putadminverifyAction,UpdatePgmDetailAction } from "../../actions/pgmlistAction";
import { notify } from '../../services/notification';
import { decode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import useMobileView from "../../constants/useMobileView";
import { MdEdit } from "react-icons/md";
import ReasonPopup from '../../component/ReasonPopup';


function PgmDetails() {
  const [state, setDataState] = useState({
    pgmdetail: [],
    mobile_number: "",
    pincode: "",
    user_name: "",
    email: "",
    city: "",
    account_number: "",
    district: "",
    state: "",
    is_approve: "",
    verification_type: "",
    verification_id: "",
    shop_name: "",
    pgm_status: "",
    profile: "",
    banner: '',
    doc_file: '',
    agency_code: '',
    refer_code: '',
    aps_code: '',
    aps_name: '',
    area_head_email: '',
    status_reason:'',
    registered_at:'',

  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {  isSidebarOpen, toggleSidebar } = useMobileView();
  const [selectedReason, setSelectedReason] = useState('');
  const [showApproveSection, setShowApproveSection] = useState(false);


  
  const dispatch = useDispatch();
  useEffect(() => {
    PgmDetailData();
  }, []);

  const { id } = useParams()
  const decodeid = decode(id)

  async function PgmDetailData() {
    let response = await dispatch(pgmdetailAction(decodeid));
    if (response == 200 || response != null) {
      setDataState({
        pgmdetail: response.data.data,
        mobile_number: response.data.data.mobile_number,
        pincode: response.data.data.pincode,
        account_number: response.data.data.account_number,
        email: response.data.data.email,
        city: response.data.data.city,
        user_name: response.data.data.name,
        district: response.data.data.district,
        state: response.data.data.state,
        is_approve: response.data.data.is_approve,
        is_deleted: response.data.data.is_deleted,
        verification_type: response.data.data.doc_type,
        verification_id: response.data.data.doc_id,
        shop_name: response.data.data.garage_name,
        shop_location: response.data.data.location,
        pgm_status: response.data.data.pgm_status,
        profile: response.data.data.profile,
        banner: response.data.data.banner,
        doc_file: response.data.data.doc_file,
        agency_code: response.data.data.agency_code,
        refer_code: response.data.data.referred_by_refer_code,
        aps_code: response.data.data.aps_code,
        aps_name: response.data.data.aps_name,
        area_head_email: response.data.data.area_head_email,
        id: response.data.data.id,
        status_reason: response.data.data.status_reason,
        registered_at: response.data.data.registered_at,
      });
    }
  }
  const handleCloseDeleteConfirmationModal = () => {
    setShowApproveSection(false);
  }
  const onadminupdate = async () => {
    const apiReq = {
      ids: [decodeid],
      pgm_status: "Approved",
      approval_reason: selectedReason 
    };

    setIsLoading(true);
    let response = await dispatch(putadminverifyAction(apiReq));
    if (response == 200 || response != null) {
      setIsLoading(false);
      notify.success(response.data.message);
      navigate('/pgmlist')
    }
  };

  const onReject = async () => {
    let apiReq = {
      "ids": [
        decodeid
      ],
      "pgm_status": "Rejected"
    }
    let response = await dispatch(putadminverifyAction(apiReq, decodeid));
    if (response == 200 || response != null) {
      notify.success(response.data.message);
      navigate('/pgmlist')
    }
  };

  const onclose = () => {
    window.scroll(0, 0);
    navigate('/pgmlist')
  }

  const [dimensions, setDimensions] = useState({ height: null, width: null });
  const [originalDimensions, setOriginalDimensions] = useState({ height: null, width: null });
  const imgRef = useRef(null);



  
  // const handleZoomOut = () => {
  //   // Set height to 15px and adjust width accordingly
  //   setDimensions({ height: 15, width: (15 / originalDimensions.height) * originalDimensions.width });
  // };

  const handleZoomOut = () => {
    // Assigning original height and width
    setDimensions(originalDimensions);
  };

  // Assign current height and width to the image
  const imgStyle = { height: dimensions.height, width: dimensions.width };


  const imageElement = document.getElementById('zoomed-image');
  let currentZoom = 100; // Initial zoom level in percentage

  function zoomIn() {
    if (currentZoom < 200) { // Set a maximum zoom level (200% in this case)
      currentZoom += 10; // You can adjust the zoom increment
      imageElement.style.width = currentZoom + '%';
      imageElement.style.height = currentZoom + '%';
    }
  }

  function zoomOut() {
    if (currentZoom > 10) {
      currentZoom -= 10;
      imageElement.style.width = currentZoom + '%';
      imageElement.style.height = currentZoom + '%';
    }
  }
  const [currentWidth, setCurrentWidth] = useState(200);


  function zoomIn() {
    if (currentWidth === 1) {
      // alert("Maximum Zoom In Level Reached.");
    } else {
      setCurrentWidth(currentWidth + 40);
    }
  }

  function zoomOut() {
    if (currentWidth === 333) {
      // alert("Maximum Zoom Out Level Reached.");
    } else {
      setCurrentWidth(currentWidth - 40);
    }
  }

  const [showFullScreen, setShowFullScreen] = useState(false);

  const handleImageClick = () => {
    setShowFullScreen(true);
  };

  const handleCloseFullScreen = () => {
    setShowFullScreen(false);
  };

  const [isPopupOpen, setIsPopupopen] = useState(false);
  function openPopup() {
    setIsPopupopen(true)

  }

  
  // Function to close the pop-up
  function closePopup() {
    setIsPopupopen(false)
  }

  const [isShopPicturePopupOpen, setIsShopPicturePopupOpen] = useState(false);
  function shopPictureOpenPopup() {
    setIsShopPicturePopupOpen(true)

  }
  // Function to close the pop-up
  function shopPictureClosePopup() {
    setIsShopPicturePopupOpen(false)
  }

  const [isVerificationPictureOpen, setIsVerificationPictureOpen] = useState(false);
  function VerificationPicturePopups() {
    setIsVerificationPictureOpen(true)

  }
  // Function to close the pop-up
  function VerificationPictureClosePopups() {
    setIsVerificationPictureOpen(false)
  }

  async function updatePgmdetail(e) {
    e.preventDefault();
    setIsLoading(true);
    let apiReq = {
      aps_code: state.aps_code,
      aps_name: state.aps_name,
      area_head_email: state.area_head_email,
      user_id: state.id, // Include the user_id in the request payload
    };
    try {
      let response = await dispatch(UpdatePgmDetailAction(apiReq, decodeid));
      if (response && response?.success) {
        setIsLoading(false);
        notify.success(response?.message);
        navigate("/pgmlist");
        window.scroll(0, 0);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataState({
      ...state,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
  };

  return (
    <div className="DetailsContainers">
      <div className="DetailsContentS pgm_details_container_s">
        <Header title="PGM Details" />
        {isLoading ? <Loader /> :
          <div className="PgmSpecialText">
            <div className="TextConatinerDetails" >
              <div className="TextContainerLeft">
             
                <div>
                  <div className="Label_name_details">
                    <label>Profile Picture</label>
                  </div>
                  <div className="input_field">

                    <img alt="img"  id="zoom"  height="80px" width="80rem" style={{ marginLeft: '0.5rem' }} onClick={openPopup} src={state.profile} />
                    {isPopupOpen && (
                      <div className="popup-overlay" onClick={closePopup}>
                        <div className="popup-images" onClick={(e) => e.stopPropagation()}>
                          <img src={Image_Url.CROSSC} className="zoominoutimgcross" onClick={closePopup} />
                          <img alt="img" className="large-image" src={state.profile} />
                        </div>
                    </div>

                    //   <div className='popup-images'
                    //   >
                    //     <div className='zoominout'>
                    //       {/* <img src={Image_Url.PLUSICONS} className='zoominoutimg' onClick={zoomIn} />
                    // <img src={Image_Url.MINUSICONS} className='zoominoutimg' onClick={zoomOut} /> */}
                    //       {/* <img src={Image_Url.CROSSC} className='zoominoutimgcross' onClick={closePopup} /> */}

                    //     </div>
                    //     <img src={Image_Url.CROSSC} className='zoominoutimgcross' onClick={closePopup} />
                    //     <img alt="img" className='large-image' width={currentWidth} src={state.profile} />

                    //   </div>
                    )}

                  </div>

                </div>
                {state.user_name && (
                  <div>
                    <div className="Label_name_details">
                      <label>
                        User Name
                      </label>
                      <input type="text"
                        name="user_name"
                        className="input_field_pgmdetails"
                        value={state.user_name ? state.user_name : "undefined"}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.mobile_number && (
                  <div>
                    <div className="Label_name_details">
                      <label>
                        Mobile Number
                      </label>
                      <input type="text"
                        name="mobile_number"
                        className="input_field_pgmdetails"
                        value={state.mobile_number}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.email && (
                  <div>
                    <div className="Label_name_details">
                      <label>Email Id</label>
                      <input type="text"
                        name="email"
                        className="input_field_pgmdetails"
                        value={state.email ? state.email : "undefined"}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.verification_type && (
                  <div>
                    <div className="Label_name_details">
                      <label>Verification Id Type</label>
                      <input type="text"
                        name="verification_type"
                        className="input_field_pgmdetails"
                        value={state.verification_type}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.verification_id && (
                  <div>
                    <div className="Label_name_details">
                      <label>Verification Id</label>
                      <input type="text"
                        name=" verification_id"
                        value={state.verification_id}
                        className="input_field_pgmdetails"
                        readOnly
                      />
                    </div>
                  </div>
                )}
                {state.doc_file && (
                  <div>
                    <div className="Label_name_details">
                      <label>Verification Id Picture</label>
                    </div>
                    <div className="input_field">
                      <img alt="img" width={currentWidth} id="zoom" height="200" onClick={shopPictureOpenPopup} src={state.doc_file} />
                      {isShopPicturePopupOpen && (
                       <div className="popup-overlay" onClick={shopPictureClosePopup}>
                        <div className='popup-images'>
                        <img src={Image_Url.CROSSC} className='zoominoutimgcross' onClick={shopPictureClosePopup} />
                        <img alt="img" className='large-image' width={currentWidth} src={state.doc_file} />
                        </div>
                        </div>
                      )}

                    </div>
                  </div>
                )}
                {state.account_number && (
                  <div>
                    <div className="Label_name_details">
                      <label>Account Number</label>
                      <input type="text"
                        name="account_number"
                        value={state.account_number}
                        className="input_field_pgmdetails"
                        readOnly />
                    </div>
                  </div>
                )}
                {state.refer_code && (
                  <div>
                    <div className="Label_name_details">
                      <label>Referral Code</label>

                      <input type="text"
                        name="refer_code"
                        value={state.refer_code}
                        className="input_field_pgmdetails"
                        readOnly
                      />
                    </div>
                  </div>
                )}
                {state.status_reason && (
                <div>
                    <div className="Label_name_details">
                      <label>Pending Reason</label>
                      <input type="text"
                        name="status_reason"
                        value={state.status_reason}
                        className="input_field_pgmdetails"
                        readOnly
                        />
                    </div>
                  </div>
                )}
                {state.registered_at && (
                <div>
                    <div className="Label_name_details">
                      <label>Registration Date</label>
                      <input type="text"
                        name="registered_at"
                        value={state.registered_at}
                        className="input_field_pgmdetails"
                        readOnly
                        />
                    </div>
                  </div>
                )}
              </div>
              <div className="TextContainerRight">
                {state.banner && (
                  <div>
                    <div className="Label_name_details">
                      <label>Shop Picture</label>
                    </div>
                    <div className="input_field">
                      <img alt="img" width={currentWidth} id="zoom" height="200" onClick={VerificationPicturePopups} src={state.banner} />
                      {isVerificationPictureOpen && (
                        <div className="popup-overlay" onClick={VerificationPictureClosePopups}>
                          <div className='popup-images' onClick={(e) => e.stopPropagation()}>
                            <img src={Image_Url.CROSSC} className='zoominoutimgcross' onClick={VerificationPictureClosePopups} />
                            <img alt="img" className='large-image' width={currentWidth} src={state.banner} />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {state.shop_name && (
                  <div>
                    <div className="Label_name_details">
                      <label>Shop Name</label>

                      <input type="text"
                        name="shop_name"
                        className="input_field_pgmdetails"
                        value={state.shop_name}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.shop_location && (
                  <div>
                    <div className="Label_name_details">
                      <label>Shop Location</label>
                      <input type="text"
                        name=" shop_location"
                        className="input_field_pgmdetails"
                        value={state.shop_location}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.city && (
                  <div>
                    <div className="Label_name_details">
                      <label>City</label>
                      <input type="text"
                        name="city"
                        value={state.city ? state.city : "undefined"}
                        className="input_field_pgmdetails"
                        readOnly />
                    </div>
                  </div>
                )}
                {state.state && (
                  <div>
                    <div className="Label_name_details">
                      <label>State</label>
                      <input type="text"
                        name="state"
                        className="input_field_pgmdetails"
                        value={state.state ? state.state : "undefined"}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.pincode && (
                  <div>
                    <div className="Label_name_details">
                      <label>
                        Pincode
                      </label>
                      <input type="text"
                        name="mobile_number"
                        className="input_field_pgmdetails"
                        value={state.pincode ? state.pincode : "undefined"}
                        readOnly
                      />
                    </div>
                  </div>
                )}
                {state.district && (
                  <div>
                    <div className="Label_name_details">
                      <label>District</label>
                      <input type="text"
                        name="district"
                        className="input_field_pgmdetails"
                        value={state.district ? state.district : "undefined"}
                        readOnly />
                    </div>
                  </div>
                )}
                {state.agency_code && (
                  <div>
                    <div className="Label_name_details">
                      <label>MSR Id</label>
                      <input type="text"
                        name="agency_code"
                        value={state.agency_code}
                        className="input_field_pgmdetails"
                        readOnly
                      />
                    </div>
                  </div>
                )}

                <div>
                 
                      <div>
                        <div className="Label_name_details">
                          <label>APS Code (<MdEdit />) </label>
                          <input
                            disabled={state.pgm_status.toLowerCase() !== "pending"}
                            type="text"
                            name="aps_code"
                            value={state.aps_code}
                            className="input_field_pgmdetails"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="Label_name_details">
                          <label>APS Name (<MdEdit />)</label>
                          <input
                            disabled={state.pgm_status.toLowerCase() !== "pending"}
                            type="text"
                            name="aps_name"
                            value={state.aps_name}
                            className="input_field_pgmdetails"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="Label_name_details">
                          <label>Area Head (<MdEdit />)</label>
                          <input
                            disabled={state.pgm_status.toLowerCase() !== "pending"}
                            type="text"
                            name="area_head_email"
                            value={state.area_head_email}
                            className="input_field_pgmdetails"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                   
                </div>
              </div>
            </div>
            {state.is_deleted ? "" :
            <div>
            {state.pgm_status.toLowerCase() === "pending" && (
              <div className="pgmdetails_button">
                <button className="pgm_buttonPending" onClick={onclose}>Close</button>
                <button className="pgm_button_approveds"
                  disabled={state.pgm_status.toLowerCase() === "approved"}
                  type="button"
                  onClick={() => setShowApproveSection(true)}
                  >Approve</button>
                <button className="pgm_buttonRejects"
                  disabled={state.pgm_status.toLowerCase() === "rejected"}
                  type="button"
                  onClick={onReject}>Reject</button>
                <button className="pgm_buttonPending" onClick={updatePgmdetail}>Update</button>
                {/* Hide the approve and reject buttons */}
              </div>
            )}
 {state.pgm_status.toLowerCase() !== "pending"  && (
              <div className="pgmdetails_button">
                <button className="pgm_buttonPending" onClick={onclose}>Close</button>
                {/* Show the approve and reject buttons */}
                <button className="pgm_button_approveds"
                  disabled={state.pgm_status.toLowerCase() === "approved"}
                  type="button"
                  onClick={() => setShowApproveSection(true)}
                  >Approve</button>
                <button className="pgm_buttonRejects"
                  disabled={state.pgm_status.toLowerCase() === "rejected"}
                  type="button"
                  onClick={onReject}>Reject</button>
              </div>
            )}
            </div>
        }
            {state.is_deleted && (
              <div className="pgmdetails_button">
                <button className="pgm_buttonPending" onClick={onclose}>Close</button>
              </div>
            )}
          </div>
        }
       
       {showApproveSection && (
       <ReasonPopup
        openDeleteModal={showApproveSection}
        isLoading={isLoading}
        selectedReason={selectedReason}
        handleCloseDeleteConfirmationModal={handleCloseDeleteConfirmationModal}
        onadminupdate={onadminupdate}
        setSelectedReason={setSelectedReason}
        />
        )}
      </div>
    </div>
  );
}
export default PgmDetails;